import {
  HTTP_INTERCEPTORS,
  HttpClientJsonpModule,
  HttpClientModule,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { HMSAvailability } from '@hmscore/ionic-native-hms-availability/ngx';
import { Screenshot } from '@ionic-native/screenshot/ngx';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { ConfirmTokenSelectionDialogModule } from './_components/confirm-token-selection-dialog/confirm-token-selection-dialog.module';
import { ConfirmTokenRedeemDialogModule } from './_components/confirm-token-redeem-dialog/confirm-token-redeem-dialog.module';
import { DeleteAccountConfirmationDialogModule } from './_components/delete-account-confirmation-dialog/delete-account-confirmation-dialog.module';
import { ErrorDialogModule } from './_components/error-dialog/error-dialog.module';
import { RedeemMemberDialogModule } from './_components/redeem-member-dialog/redeem-member-dialog.module';
import { RedeemPartnerDialogModule } from './_components/redeem-partner-dialog/redeem-partner-dialog.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppService } from './app.service';
import { HttpInterceptorService } from './http-interceptor.service';
import { TranslationsService } from './translations.service';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslationsService,
        deps: [AppService],
      },
    }),
    HttpClientModule,
    HttpClientJsonpModule,
    IonicStorageModule.forRoot(),
    NgbModule,
    ConfirmTokenSelectionDialogModule,
    ConfirmTokenRedeemDialogModule,
    ErrorDialogModule,
    RedeemMemberDialogModule,
    RedeemPartnerDialogModule,
    MatDialogModule,
    MatDividerModule,
    MatToolbarModule,
    MatBottomSheetModule,
    DeleteAccountConfirmationDialogModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    Screenshot,
    // [2023-10-17 @ Dino] Added for Huawei
    HMSAvailability,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
